export default __webpack_public_path__ + "static/media/MySQL-WindowsTaskScheduler-Finish07.5787fc60.png";